import { ConfirmComponentView } from '../ConfirmComponentView';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';

/**
 * 申込内容確認画面保険項目(OTA/DTP)切替モード
 */
export class ConfirmItemMode extends WprBaseViewModeInfo<ConfirmComponentView>{
	// DI情報  ------------------------------------------------------------------
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('confirmItemMode');
	}
	// --------------------------------------------------------------------------
	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('OTA');
		list.push('DTP');
	}

	/**
	 * フィールド定義を登録
	 */
	public onRegisterControl(): void {
		this.addControl('explanation', { value: [{ mode: 'OTA', value: '本プランは、海外旅行中におけるケガや病気による治療費および偶然な事故による賠償責任などに備える保険です。' }, { mode: 'DTP', value: '本プランは、国内旅行中におけるケガによる入院・通院および偶然な事故による賠償責任などに備える保険です。' },], });
		this.addControl('insuranceType', { value: [{ mode: 'OTA', value: '海外旅行傷害保険' }, { mode: 'DTP', value: '国内旅行傷害保険' },], });
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		return this.getGlobalMode('product');
	}
	// --------------------------------------------------------------------------
}